import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { IconButton, Tooltip } from '@mui/material';

export const DeleteButtonIcon = ({ onClick, title }: any) => {
  return (
    <Tooltip onClick={onClick} title={title}>
      <IconButton aria-label="delete">
        <DeleteOutlineRoundedIcon style={{ fill: '#ef4444', fontSize: '22px' }} />
      </IconButton>
    </Tooltip>
  );
};
